import axios from "axios";

export const getCategoriesFromDb = () => {
  return axios(
    "/api/categories?select=id,name,description,is_visible,show_in_step_3,pin_icons(icon)&order=sort_order.asc"
  ).then((response) => {
    return response.data
      .filter((category) => category.is_visible)
      .map((category) => {
        return {
          id: category.id,
          name: category.name,
          description: category.description,
          pinIcon: category.pin_icons?.icon,
          showInStep3: category.show_in_step_3,
        };
      });
  });
};
